import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { storeActive } from 'ggApp/modules/store';
import { createStructuredSelector } from 'reselect';

import { registerSearchOverlayEvent } from 'ggApp/modules/gaAnalytics/actions';
import Products from './Products';

const enhance = compose(
    connect(
        createStructuredSelector({
            storeActive,
        }),
        (dispatch) => ({
            registerSearchOverlayEvent: bindActionCreators(registerSearchOverlayEvent, dispatch),
        }),
    ),
);

export default enhance(Products);
